export default __webpack_public_path__ + "Student-Teacher-Laptop.png";